import React, { FC } from 'react';
import { Breadcrumbs } from '@digdir/designsystemet-react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  BreadcrumbsWrapper,
  MainContentWrapper,
  PageLayout
} from '../../../registrationV2025/components/styledComponents';
import { PageLoader } from '../../../registrationV2025/components/pageLoader';
import { useBuildingData } from '../../../../hooks/useBuildingDetails/buildingDetailsHooks';
import { GetEnergiObjektTypeFromMatrikkel } from '../../../../utils/matrikkelBygningsTyper';

import { TiltakForm } from './form';
import { TiltakFormData } from './form/types';
import { useUpdateTiltak } from './hooks/useUpdateTiltak';
import { formDataToTiltak, fromTiltakToFormData } from './utils';
import { useGetTiltak } from './hooks/useGetTiltak';

export const UpdateTiltakForm: FC = () => {
  const { tiltakId, buildingId } = useParams();

  const { building, buildingLoading } = useBuildingData(buildingId);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const energiobjekttype = GetEnergiObjektTypeFromMatrikkel(building?.kanEnergimerkesAvPrivatPerson || false);

  const { tiltak, isLoading: isGettingTiltak } = useGetTiltak(tiltakId || '');
  const { updateTiltak } = useUpdateTiltak(tiltak?.energiplanId);

  const onSubmit = (formData: TiltakFormData) => {
    const tiltak = formDataToTiltak(formData);
    updateTiltak(tiltak, {
      onSuccess: () => navigate('../')
    });
  };

  if (buildingLoading || isGettingTiltak) {
    return <PageLoader />;
  }

  const defaultValues = tiltak ? fromTiltakToFormData(tiltak) : undefined;

  return (
      <PageLayout>
        <BreadcrumbsWrapper>
          <Breadcrumbs>
            <Breadcrumbs.Link asChild aria-label={t('registrering.back')}>
              <Link to="../">{t('screens.energiplan.components.tiltakForm.index.backLink')}</Link>
            </Breadcrumbs.Link>
          </Breadcrumbs>
        </BreadcrumbsWrapper>
        <MainContentWrapper>
          <TiltakForm onSubmit={onSubmit} defaultValues={defaultValues} energiobjekttype={energiobjekttype} />
        </MainContentWrapper>
      </PageLayout>
  );
};
